import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { useRequestOrigins } from "../../../../hooks/useRequestOrigins";
import { type OpenShiftRequest, type ReplaceShiftRequest, RequestOriginsStatus } from "../../../../utils/models";
import { RequestOriginsLoadNotice } from "../../../RequestData/RequestOrigin/RequestOriginsLoadNotice";
import { RequestItem } from "../../../RequestData/RequestsTab/RequestItem";
import { useRequestItemActions } from "../../../RequestData/RequestsTab/useRequestItemActions";
import SystemBanner from "../../../UIToolkit/molecules/SystemBanner";

interface IProps {
	requests: OpenShiftRequest[] | ReplaceShiftRequest[];
}

export const PostedShiftsList = ({ requests }: IProps) => {
	const { t } = useTranslation();
	const { handlers, dialogs } = useRequestItemActions();
	const { chosenDepartment } = useHospitalData();
	const origins = useRequestOrigins(chosenDepartment.department_id, requests);

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
			{origins.status === RequestOriginsStatus.Loading && (
				<SystemBanner live layout="inline" title={t("request.origin.filter.loading")} dataTestId="request-origins-loading" />
			)}
			{origins.status === RequestOriginsStatus.Failed && <RequestOriginsLoadNotice departmentId={chosenDepartment.department_id} retry={origins.retry} />}
			{requests.map((request: OpenShiftRequest | ReplaceShiftRequest) => (
				<RequestItem
					key={request.id}
					request={request}
					onDelete={handlers.onDelete}
					onBroadcast={handlers.onBroadcast}
					onEditNeededNurses={handlers.onEditNeededNurses}
					onShowAll={handlers.onShowAll}
					onTimeChange={handlers.onTimeChange}
					origins={origins.byRequestId.get(request.id) ?? null}
				/>
			))}
			{dialogs}
		</Box>
	);
};
